import { refinementList, sortBy } from 'instantsearch.js/es/widgets';
import { getInstance, registerWidget } from './algolia-create-instance';
import { addFilter } from '@wordpress/hooks';

function initRefinementListWidget() {

  const tgblAlgoliaDataJSON = window.atob(tgblAlgoliaDataEncoded)
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON)
  
  // TODO: Translations
  //const LOCALIZED = tgblAlgoliaData.localized;

  // Get all elements with refinement list class
  const elements = document.querySelectorAll("[data-filter-type='refinementList']")
  const elementsArray = Array.from(elements)
  
  // Group together refinement list elements that share an index
  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  // Loop through each index
  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);
      
      // Perform actions on elements with the same data-index value
      elementsWithSameIndex.forEach(element => {

        const widgetID = element.getAttribute('data-id')
        const widgetData = tgblAlgoliaData[widgetID]
        const attribute = widgetData.attribute
      
        let facetMappings = []
        if ( widgetData.facet_mapping ) {
          facetMappings = transformFacetMappingToDict(widgetData.facet_mapping)
        }

        let sortByArgs =  ["isRefined", "count:desc", "name:asc"]

        if ( widgetData.refinement_list_sort ) {
          sortByArgs = Object.values(widgetData.refinement_list_sort)
        }

        // If this widget declares preselected refinements, contribute them via a filter
        if (widgetData.preselected_refinements) {
          const normalizedValues = normalizeRefinements(widgetData.preselected_refinements);
          if (normalizedValues.length > 0) {
            const ns = `tangible/refinementlist/${dataIndexValue}/${widgetID}`;
            addFilter(
              'tangible-algolia-preselect-refinement',
              ns,
              (plan) => {
                plan.push({
                  indexName: dataIndexValue,
                  attribute,
                  values: normalizedValues,
                });
                return plan;
              }
            );
          }
        }
        

        let AlgoliaRefinementList = ($, search, element) => {
          search.addWidgets([
            refinementList({
              container: element,
              attribute: attribute, 
              cssClasses: {
                root: '',
                list: 'tgbl-refinement-list',
                item: 'tgbl-refinement-list__item tgbl-refinement-item',
                selectedItem: '',
                label: 'tgbl-refinement-item__label',
                labelText: 'tgbl-refinement-item__text',
                checkbox: 'tgbl-refinement-item__checkbox',
                count: 'tgbl-refinement-item__count',
              },
              sortBy: sortByArgs,
              transformItems(items) {
                return items.map(item => ({
                  ...item,
                  label: facetMappings[item.label] ?? item.label,
                  highlighted: facetMappings[item.label] ?? item.label
                })
              )}
            })
          ]);
          registerWidget(element);
        };
        AlgoliaRefinementList($, search, element);
      });
    }
  }
}

// TODO: consolidate this somewhere to be re-used by all the widgets which need it
const transformFacetMappingToDict = (facetMappingObject) => {
    const facetDictionary = {};
    Object.values(facetMappingObject).forEach(facet => {
        facetDictionary[facet.facet_value] = facet.new_facet_value_label;
    });
    return facetDictionary;
};

export { initRefinementListWidget }

function normalizeRefinements(input) {
  // Already an array? Use it.
  let arr = Array.isArray(input) ? input : null;

  // If it’s an object (e.g., {0: {...}, 1: {...}}), convert to array
  if (!arr && input && typeof input === 'object') {
    arr = Object.values(input);
  }

  // Single primitive? Wrap
  if (!arr) {
    arr = (input == null) ? [] : [input];
  }

  // Map entries to strings Algolia understands
  return arr
    .map(item => {
      if (item && typeof item === 'object') {
        // Prefer "value", fallback to "label", else JSON string of object
        const candidate = item.value ?? item.label;
        return candidate != null ? String(candidate) : JSON.stringify(item);
      }
      return String(item);
    })
    .filter(v => v.length > 0);
}